export default __webpack_public_path__ + "static/media/0000..0006.9f5336a2.png";